var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.473 18.673a.292.292 0 01.274.076l2.5 2.503a.292.292 0 01-.117.484l-3.746 1.25a.292.292 0 01-.369-.37l1.249-3.75a.292.292 0 01.209-.193zm7.557-7.633a.3.3 0 01.412 0l2.498 2.501a.292.292 0 010 .413l-6.66 6.665a.292.292 0 01-.413 0l-2.497-2.5a.292.292 0 010-.413zm1.459-1.457a2.107 2.107 0 012.91 0c.801.805.801 2.106 0 2.91l-.416.42a.292.292 0 01-.413 0l-2.497-2.5a.292.292 0 010-.413z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgPencil;